<template>
	<div class="wrapper" v-if="$store.getters.user">
		<Header></Header>
		<Menu></Menu>
		<router-view />
		<Footer></Footer>
	</div>
	<div class="wrapper" v-else>
		<router-view />
	</div>
</template>

<script>
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import Footer from "@/components/Footer.vue";
export default {
	name: "App",
	components: { Header, Menu, Footer },

	created() {
		if (localStorage.getItem("user")) {
			this.$store.dispatch("setUser", JSON.parse(localStorage.getItem("user")));
		}
		if (localStorage.getItem("token")) {
			this.$store.dispatch("setToken", localStorage.getItem("token"));
		}
		if (localStorage.getItem("permissions")) {
			this.$store.dispatch("setPermissions",JSON.parse(localStorage.getItem("permissions")));
		}
	},
};
</script>
